<template>
  <el-row>
    <el-row type="flex" justify="end">
      <el-date-picker
        v-model="date"
        type="month"
        placeholder="Seleccione mes y año"
        :clearable="false"
        :editable="false"
        @change="fetchReport"
      >
      </el-date-picker>
    </el-row>
    <el-col>
      <rabbey-table-3
        :loading="loading"
        :data="tableData"
        :columns="columnsData"
        border
        stripe
      />
    </el-col>
  </el-row>
</template>

<script>
export default {
  created() {
    this.fetchReport();
  },
  data() {
    return {
      loading: false,
      tableData: [],
      columnsData: [
        {
          prop: "title",
          label: "Tipos de Solicitudes",
          align: "center"
        },
        {
          prop: "TotalRequest",
          label: "Solicitudes Recibidas",
          align: "center"
        },
        {
          prop: "OnTimeRequest",
          label: "Solicitudes Atendidas dentro del SLA",
          align: "center"
        },
        {
          prop: "LateRequest",
          label: "Solicitudes Atendidas fuera del SLA",
          align: "center"
        }
      ],
      date: new Date()
    };
  },

  methods: {
    fetchReport() {
      this.loading = true;
      this.$http
        .get("/api/serviceRequests/GetRquestReport", {
          params: {
            Year: this.date.getFullYear(),
            Month: this.date.getMonth() + 1
          }
        })
        .then(({ data }) => {
          this.tableData = data;
          this.loading = false;
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    }
  }
};
</script>
